import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import { ListBulletIcon, LinkIcon } from "@heroicons/react/24/outline";

export const ValidationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleTabChange = (event: any, newValue: string) => {
    navigate(newValue);
  };

  const getTabValue = () => {
    switch (location.pathname) {
      case "/validation-rules":
      case "/validation-rules/rules-templates":
        return "/validation-rules";
      case "/validation-rules/rules-assign":
        return "/validation-rules/rules-assign";
      default:
        return "/validation-rules";
    }
  };

  return (
    <Box>
      <Tabs value={getTabValue()} onChange={handleTabChange}>
        <Tab
          onClick={() => navigate("/validation-rules")}
          label={
            <Box sx={{ display: "flex", gap: 1 }}>
              <ListBulletIcon width={16} height={16} />
              Rules Templates
            </Box>
          }
          value="/validation-rules"
        />
        <Tab
          label={
            <Box sx={{ display: "flex", gap: 1 }}>
              <LinkIcon width={16} height={16} />
              Assign Templates
            </Box>
          }
          value="/validation-rules/rules-assign"
        />
      </Tabs>
      <Box sx={{ pt: 3 }} />
      <Outlet />
    </Box>
  );
};
